import { EntityMetadataMap } from '@ngrx/data';

const entityMetadata: EntityMetadataMap = {
  Product: {},
};

export const entityConfig = {
  entityMetadata,
};
